import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class BreadCrumbBillingL10n {
  public static billing = _('breadcrumb.billing');
  public static billingList = _('breadcrumb.billingList');
  public static createTva = _('breadcrumb.createTva');
  public static createManualBill = _('breadcrumb.createManualBill');
  public static createBill = _('breadcrumb.createBill');
}
